import { Pipe, PipeTransform } from '@angular/core';

import { Utils } from 'app/utils/utils';

@Pipe({
  name: 'roundHalfAway',
  standalone: false,
})
export class RoundHalfAwayPipe implements PipeTransform {
  transform(value: number, decimal = 1): number {
    return Utils.roundHalfAway(value, decimal);
  }
}
